import equal from 'fast-deep-equal';

// wraps package https://github.com/epoberezkin/fast-deep-equal
// allows for easier/auto typescript import instead of doing `import * as equal`
export function isDeepEqual(a: any, b: any): boolean {
  return equal(a, b);
}
